import {
  CARD,
  IMAGE,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  PLAY_BUTTON,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia3: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        columns.items.push({
          id: 'LAYOUT_LIST',
          type: LAYOUT_LIST,
          values: { align: 'center' },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'lg',
                height: '500px',
                width: '300px',
                padding: '0px'
              },
              items: [
                {
                  id: `${item.pictures?.[0].id}`,
                  type: IMAGE,
                  values: {
                    url: item.pictures?.[0].mediaUrl,
                    alt: item.pictures?.[0].name,
                    editButtonOneTheImage: true,
                    role: 'region'
                  },
                  items: [
                    {
                      id: 'LAYOUT_LIST_RIGHT',
                      type: LAYOUT_LIST,
                      values: { align: 'center' },
                      items: [
                        {
                          type: PLAY_BUTTON,
                          id: `${item.id}_audios`,
                          values: {
                            blocking: true,
                            showProgress: true,
                            mediaUrl:
                              item.audios && item.audios.length
                                ? item.audios[0].mediaUrl
                                : '',
                            subtitlesUrl:
                              item.audios && item.audios.length
                                ? item.audios[0].subtitlesUrl
                                : ''
                          },
                          items: []
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        });
        break;
      case 'Text':
      case 'Question':
        columns.items.push({
          id: 'LAYOUT_LIST_RIGHT',
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            padded: false,
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading2'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });
  root.items.push(columns);
  return root;
};
